import React from 'react';
import { formatNameForDisplay } from '../../utils/nameUtils';
import { getPlayerNameColor } from '../../utils/playerUtils';
import PlayerSelectionDropdown from './PlayerSelectionDropdown';

/**
 * Simplified team panel for private sessions
 * Just shows player names without ELO complexity
 */
export default function SimpleTeamPanel({
  team = [],
  teamNumber,
  playersById = {},
  isWinner = false,
  canRemove = false,
  onRemovePlayer,
  onAddPlayer,
  courtNumber,
  availablePlayers = []
}) {
  const isTeam1 = teamNumber === 1;
  const bgColor = isWinner ? 'bg-success-light' : (isTeam1 ? 'bg-team1-light' : 'bg-team2-light');
  const ringColor = isWinner ? 'ring-success' : (isTeam1 ? 'ring-team1' : 'ring-team2');
  const textColor = isTeam1 ? 'text-text-primary' : 'text-text-primary';

  return (
    <div className={`${bgColor} p-2 rounded-md ${ringColor} ring-1 flex flex-col min-w-0 w-full`}>
      <div className="flex justify-between items-center mb-1">
        <span className={`text-xs font-semibold ${isTeam1 ? 'text-team1' : 'text-team2'}`}>Team {teamNumber}</span>
      </div>
      <ul className="flex flex-col gap-1 w-full">
        {/* Render existing players */}
        {team.map((playerId, idx) => {
          const player = playersById[playerId];
          if (!player) return null;
          
          return (
            <li key={playerId} className="w-full">
              <div className="group flex items-center justify-between w-full px-3 py-2 bg-surface rounded-lg border border-border-medium hover:bg-surface-subtle">
                <div className="flex items-center space-x-2">
                  <div className="w-6 h-6 bg-primary/15 rounded-full flex items-center justify-center">
                    <span className="text-xs font-semibold text-primary">
                      {player.first_name[0]}
                    </span>
                  </div>
                  <span className={`text-sm font-medium ${getPlayerNameColor(player.gender)}`}>
                    {player.first_name} {player.last_name}
                  </span>
                </div>
                {canRemove && (
                  <button
                    onClick={() => onRemovePlayer(playerId, teamNumber, courtNumber)}
                    className="text-danger hover:text-danger-dark text-xs"
                    title="Remove from court"
                  >
                    ×
                  </button>
                )}
              </div>
            </li>
          );
        })}
        
        {/* Render empty slots when team has less than 2 players */}
        {team.length < 2 && (
          Array.from({ length: 2 - team.length }, (_, idx) => (
            <li key={`empty-${idx}`} className="w-full">
              <PlayerSelectionDropdown
                availablePlayers={availablePlayers}
                onSelectPlayer={onAddPlayer}
                courtNumber={courtNumber}
                teamNumber={teamNumber}
                isSocialSession={true}
              />
            </li>
          ))
        )}
      </ul>
    </div>
  );
}
